module.exports = __webpack_public_path__ + "img/ftl-1.ae31f750.png";